import React from 'react';
import {SectionMain, Tabs, Tab, FormDialog} from 'components/core';
import TagsList from './list';
import Singletons from 'controllers/Singletons';
import {TagsCtx} from 'components/dataProviders/tags';


export default function Tags()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [newDialogOpen, setNewDialogOpen] = React.useState(false);
    const [newDialogLoading, setNewDialogLoading] = React.useState(false);

     const ctx = React.useContext(TagsCtx);


    const handleNewButtonClick = () =>
    {
      setNewDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setSelectedTab(index);
      }
    }
  
    const handleNewDialogClose = () => {
      setNewDialogOpen(false);
    };

    const handleNewDialogConfirm = (values) => {
      values.users = {
        experts: values.expert,
        operators: Singletons.currentUser.userID
      }
      delete values.expert;
      setNewDialogLoading(true);
      ctx.funcs.create(values).then(() => {
        setNewDialogLoading(false);
        setNewDialogOpen(false);
      });
    }

    const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Etiquetas Activas"/>
        <Tab label="Etiquetas Archivadas"/>
    </Tabs>

    return <SectionMain title="Etiquetas" buttonLabel="Nueva Etiqueta" tabs={tabs} onButtonClick={() => handleNewButtonClick()} buttonDisabled={Singletons.currentUser.profiles.indexOf("administrators") === -1}>
      <FormDialog
      open={newDialogOpen}
      onClose={handleNewDialogClose}
      onConfirm={handleNewDialogConfirm}
      title="Crear Etiqueta"
      subtitle="Crea una nueva etiqueta para utilizar en asistencias y procedimientos"
      confirm="Crear Etiqueta"
      cancel="Cancelar"
      loading={newDialogLoading}
      fields={[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "",
          mandatory: true,
          value: ''
        }
      ]}
      />

      <TagsList dataset={selectedTab === 0 ? "open": "closed"}/>
    </SectionMain>
}
